<script>
import events from './mixins/events.js'
import utils from './mixins/utils.js'
import AppBar from './components/AppBar.vue'
import SearchForm from './components/SearchForm.vue'
import DataIterator from './components/DataIterator.vue'
import DataFilters from './components/DataFilters.vue'
import SavedDatasets from './components/SavedDatasets.vue'
import { useSearchStore } from './stores/search'
import { configureApi } from './services/api'

export default {
  name: 'DataDiscovery',
  mixins: [events, utils],
  components: { AppBar, SearchForm, DataIterator, DataFilters, SavedDatasets },
  props: {
    mfConfig: {
      type: Object,
      default: undefined,
    },
    realm: {
      type: String,
      default: undefined,
    },
  },

  data() {
    return {
      containerState: 'expanded',
      searchStore: useSearchStore(),
    }
  },

  provide() {
    return {
      mfConfig: this.mfConfig,
      realm: this.realm
    }
  },

  created() {
    // Configure API with mfConfig and realm
    if (this.mfConfig && this.realm) {
      configureApi(this.mfConfig, this.realm)
    } else {
      console.warn('[Data Discovery] mfConfig or realm not provided - API calls may fail')
    }
  },

  mounted() {
    document.addEventListener('language-localstorage-changed', (event) => {
      this.setLocale(event.detail.storage)
    })

    this.containerState = localStorage.getItem('sidenav') === 'opened' ? 'reduced' : 'expanded'

    document.addEventListener('sidenav-localstorage-changed', (event) => {
      this.containerState = event.detail.storage === 'opened' ? 'reduced' : 'expanded'
    })
  },
}
</script>
<template>
  <v-app>
    <v-main :class="containerState">
      <v-container class="pa-0 mx-0" :fluid="true">
        <!-- Toolbar -->
        <AppBar :realm="realm" :mfConfig="mfConfig" />
        <v-sheet id="main-container">
          <v-container>
            <!-- V-Window for switching between search and saved views -->
            <v-window v-model="searchStore.currentView" :touch="false" class="pa-1">
              <!-- Search View -->
              <v-window-item value="search">
                <v-row>
                  <v-col cols="12">
                    <SearchForm />
                  </v-col>
                </v-row>
                <v-row v-if="searchStore.results.length > 0">
                  <v-col cols="12">
                    <DataFilters />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <DataIterator />
                  </v-col>
                </v-row>
              </v-window-item>

              <!-- Saved Datasets View -->
              <v-window-item value="saved">
                <SavedDatasets />
              </v-window-item>
            </v-window>
          </v-container>
        </v-sheet>
      </v-container>
    </v-main>
  </v-app>
</template>

<style scoped>
  main.expanded {
    margin-left: 56px;
  }

  main.expanded header#upp-bar {
    margin-left: 56px;
    width: calc(100% - 56px) !important;
  }

  main.reduced {
    margin-left: 256px;
  }

  #main-container {
    height: calc(100vh - 104px);
    overflow-y: auto;
    background-color: white;
  }
</style>
